import axiosV1 from '@/plugins/axios/configV1';
import axiosNotify from '@/plugins/axios/configNotify';

export default {
  getNotificationCount() {
    return axiosV1.get('dot/notifications');
  },
  getCheckProcessing() {
    return axiosNotify.get('check/import/processing');
  },
  getNotificationCompletion() {
    return axiosNotify.get('notify/approve-all/completion');
  },
	getBellNotifications(params = {}) {
		return axiosV1.get("notifications/bell", { params });
	},
	getViewAllNotifications(params = {}) {
		return axiosV1.get("notifications", { params });
	},

	/* In-App Notifications */
	getInAppNotifications(params = {}) {
		return axiosV1.get("notifs/in-app", { params });
	},
	getDeletedInAppNotifications(params = {}) {
		return axiosV1.get("notifs/in-app/deleted", { params });
	},
	getInAppNotification(id) {
		return axiosV1.get(`notifs/in-app/${id}`);
	},
	createInAppNotification(payload = {}) {
		return axiosV1.post("notifs/in-app", payload);
	},
	updateInAppNotification(id, payload = {}) {
		return axiosV1.put(`notifs/in-app/${id}`, payload);
	},
	cancelInAppNotification(id) {
		return axiosV1.post(`notifs/in-app/${id}/cancel`);
	},
	deleteInAppNotification(id) {
		return axiosV1.post(`notifs/in-app/${id}/delete`);
	},
	forceDeleteInAppNotification(id) {
		return axiosV1.post(`notifs/in-app/${id}/forceDelete`);
	},
	previewInAppNotificationTarget(payload = {}) {
		return axiosV1.post("notifs/in-app/preview-target", payload);
	},
	getInAppNotificationStatusOptions() {
		return axiosV1.get("notifs/in-app/options/statuses");
	},
	getInAppNotificationEventOptions(params = {}) {
		return axiosV1.get("notifs/in-app/options/events", { params });
	},
	getInAppNotificationAdOptions(params = {}) {
		return axiosV1.get("notifs/in-app/options/ads", { params });
	},
	getInAppNotificationProductOptions(params = {}) {
		return axiosV1.get("notifs/in-app/options/products", { params });
	},
	getInAppNotificationUserOptions(params = {}) {
		return axiosV1.get("notifs/in-app/options/users", { params });
	},
};
